export default __webpack_public_path__ + "static/media/144.fa26b5fe.png";